import { render, staticRenderFns } from "./CategoryAndMerchantTab.vue?vue&type=template&id=d949fea0&"
import script from "./CategoryAndMerchantTab.vue?vue&type=script&lang=js&"
export * from "./CategoryAndMerchantTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports